import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Logo />
            </div>
            <p className="footer-description">
              Streamline your address management with automatic ZIP code-based field population.
            </p>
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/why-us">Why Us?</Link></li>
              <li><Link to="/setup-guide">Setup Guide</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
            </ul>
          </div>
          
          <div className="footer-links">
            <h3>Resources</h3>
            <ul>
              <li><Link to="/support">Support</Link></li>
              <li><Link to="/setup-guide">Integration Guide</Link></li>
              <li><a href="mailto:info@zipcodeautofill.com">Contact Us</a></li>
            </ul>
          </div>
          
          <div className="footer-links">
            <h3>Legal</h3>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} ZipCode AutoFill. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 